
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.344 2.343h-.001a8 8 0 0111.314 11.314A8.002 8.002 0 01.234 10.089a8 8 0 012.11-7.746zm1.06 10.253a6.5 6.5 0 109.108-9.275 6.5 6.5 0 00-9.108 9.275zM6.03 4.97L8 6.94l1.97-1.97a.749.749 0 011.275.326.749.749 0 01-.215.734L9.06 8l1.97 1.97a.749.749 0 01-.326 1.275.749.749 0 01-.734-.215L8 9.06l-1.97 1.97a.749.749 0 01-1.275-.326.749.749 0 01.215-.734L6.94 8 4.97 6.03a.751.751 0 01.018-1.042.751.751 0 011.042-.018z"}})])
          )
        }
      }
    